var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 5.25C7.96648 5.25 8.74998 4.4665 8.74998 3.5C8.74998 2.5335 7.96648 1.75 6.99998 1.75C6.03348 1.75 5.24998 2.5335 5.24998 3.5C5.24998 4.4665 6.03348 5.25 6.99998 5.25ZM6.41665 3.5C6.41665 3.17783 6.67781 2.91667 6.99998 2.91667C7.32215 2.91667 7.58331 3.17783 7.58331 3.5C7.58331 3.82217 7.32215 4.08333 6.99998 4.08333C6.67781 4.08333 6.41665 3.82217 6.41665 3.5Z",
    fill: "#242423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 12.25C7.96648 12.25 8.74998 11.4665 8.74998 10.5C8.74998 9.5335 7.96648 8.75 6.99998 8.75C6.03348 8.75 5.24998 9.5335 5.24998 10.5C5.24998 11.4665 6.03348 12.25 6.99998 12.25ZM6.41665 10.5C6.41665 10.1778 6.67781 9.91667 6.99998 9.91667C7.32215 9.91667 7.58331 10.1778 7.58331 10.5C7.58331 10.8222 7.32215 11.0833 6.99998 11.0833C6.67781 11.0833 6.41665 10.8222 6.41665 10.5Z",
    fill: "#242423"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4166 7C13.4166 7.9665 12.6331 8.75 11.6666 8.75C10.7001 8.75 9.91665 7.9665 9.91665 7C9.91665 6.0335 10.7001 5.25 11.6666 5.25C12.6331 5.25 13.4166 6.0335 13.4166 7ZM11.6666 6.41667C11.3445 6.41667 11.0833 6.67783 11.0833 7C11.0833 7.32217 11.3445 7.58333 11.6666 7.58333C11.9888 7.58333 12.25 7.32217 12.25 7C12.25 6.67783 11.9888 6.41667 11.6666 6.41667Z",
    fill: "#242423"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33331 8.75C3.29981 8.75 4.08331 7.9665 4.08331 7C4.08331 6.0335 3.29981 5.25 2.33331 5.25C1.36681 5.25 0.583313 6.0335 0.583313 7C0.583313 7.9665 1.36681 8.75 2.33331 8.75ZM1.74998 7C1.74998 6.67783 2.01115 6.41667 2.33331 6.41667C2.65548 6.41667 2.91665 6.67783 2.91665 7C2.91665 7.32217 2.65548 7.58333 2.33331 7.58333C2.01115 7.58333 1.74998 7.32217 1.74998 7Z",
    fill: "#242423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.a3b5618a23f31a2bc1998037a950e420.svg";
export { ForwardRef as ReactComponent };